import script from "./IncidentInvestigationFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./IncidentInvestigationFormView.vue?vue&type=script&setup=true&lang=js"

import "./IncidentInvestigationFormView.vue?vue&type=style&index=0&id=146b24ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-146b24ee"]])

export default __exports__